import { useState } from "react";
import QRCode from "react-qr-code";
import { Grid, Box, Typography, MenuItem, Select } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "./Button";

const QRModal = ({ yardOptions, companyId, onClose }) => {
  const [selectedYard, setSelectedYard] = useState("all");
  const [generated, setGenerated] = useState(false);

  const url =
    selectedYard === "all"
      ? `${window.location.origin}/container-lookup/${companyId}`
      : `${window.location.origin}/container-lookup/${companyId}/${selectedYard}`;

  const handleDownload = () => {
    const svg = document.querySelector("#yard-qr-svg svg");
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    const canvas = document.createElement("canvas");
    canvas.width = 200;
    canvas.height = 200;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, 200, 200);
      ctx.drawImage(img, 0, 0, 200, 200);
      URL.revokeObjectURL(url);

      const a = document.createElement("a");
      a.download = "yard-qr.png";
      a.href = canvas.toDataURL("image/png");
      a.click();
    };
    img.src = url;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          background: "#fff",
          borderRadius: "18px",
          width: "100%",
          maxWidth: 500,
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: "20px 22px 16px",
            borderBottom: "1px solid #f1f5f9",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}
            >
              Generate yard QR
            </Typography>
            <Typography sx={{ fontSize: 12, color: "#64748b", mt: "2px" }}>
              Select a yard to generate its public QR code
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ p: "20px 22px" }}>
          <Typography
            sx={{ fontSize: 12, fontWeight: 600, color: "#374151", mb: "6px" }}
          >
            Select yard <span style={{ color: "red" }}>*</span>
          </Typography>
          <Select
            size="small"
            value={selectedYard}
            sx={{ width: "200px" }}
            onChange={(e) => {
              setSelectedYard(e.target.value);
              setGenerated(false);
            }}
          >
            <MenuItem value="all">All Yards</MenuItem>
            {yardOptions.map((y) => (
              <MenuItem key={y.value} value={y.value}>
                {y.label}
              </MenuItem>
            ))}
          </Select>

          <Box
            sx={{
              background: "#f8fafc",
              borderRadius: "12px",
              border: "1px solid #e8ecf4",
              p: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "14px",
              mt: "16px",
            }}
          >
            {generated ? (
              <div
                id="yard-qr-svg"
                style={{
                  background: "#fff",
                  padding: "8px",
                  borderRadius: "8px",
                }}
              >
                <QRCode
                  value={url}
                  size={148}
                  bgColor="#ffffff"
                  fgColor="#0f172a"
                  level="M"
                />
              </div>
            ) : (
              <Box
                sx={{
                  width: 164,
                  height: 164,
                  background: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #e8ecf4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    color: "#94a3b8",
                    textAlign: "center",
                    p: "10px",
                  }}
                >
                  Click Generate QR
                  <br />
                  to create
                </Typography>
              </Box>
            )}
            {generated && (
              <Typography
                sx={{
                  fontSize: 10,
                  color: "#94a3b8",
                  fontFamily: "monospace",
                  textAlign: "center",
                  wordBreak: "break-all",
                  maxWidth: 200,
                }}
              >
                {url}
              </Typography>
            )}
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{ p: "0 22px 20px", display: "flex", gap: "8px" }}>
          <Button
            fullWidth
            variant="contained"
            label={"Generate QR"}
            onClick={() => setGenerated(true)}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              background: "linear-gradient(135deg, #3182ce, #2b6cb0)",
            }}
          />
          <Button
            fullWidth
            variant="outlined"
            label={"Download PNG"}
            disabled={!generated}
            onClick={handleDownload}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              borderColor: "#e2e8f0",
              color: "#374151",
              "&:hover": { background: "#f1f5f9" },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
export default QRModal;
